export const signUpCardConfigs = [
  {
    id: "VFR",
    userTypekey: "commercial-verifier",
    icon: "/icons/signup-verifyer.png",
    name: "Commercial Verifier",
    description: "For registered employment verification companies:",
    info: [
      "Create your Lystproof account to search and verify candidate profiles instantly.",
      "Enjoy a quick, secure, end-to-end verification process.",
      "Perfect for bulk verifications - save on time and costs.",
      "Build trust with employers through faster, reliable verification.",
    ],
    buttonText: "Coming soon",
    isActive: false,
  },
  {
    id: "ORG",
    userTypekey: "organization",
    icon: "/icons/signup-organiser.png",
    name: "Organization",
    description: "For registered employers:",
    info: [
      "Set up your Lystproof account to secure employee records.",
      "Generate revenue by offering verification services to other companies.",
      "Streamline onboarding with fast, dependable digital verifications.",
      "Replace slow, costly manual checks with a reliable online process.",
    ],
    buttonText: "Sign up",
    isActive: true,
  },
  {
    id: "IDV",
    userTypekey: "individual",
    icon: "/icons/signup-individual.png",
    name: "Individual",
    description: "For students, graduates, job seekers, and employees:",
    info: [
      "Create your Lystproof account to maintain a verified employment profile.",
      "Make it easy for employers to verify your credentials.",
      "Benefit from a secure, fast, digital process with no third-party delays.",
      "Easily update your profile and link it to your organization.",
    ],
    buttonText: "Coming soon",
    isActive: false,
  },
];

export const signinCardConfigs = [
  {
    id: "VFR",
    userTypekey: "commercial-verifier",
    icon: "/icons/signup-verifyer.png",
    name: "Commercial Verifier",
    description: "For registered employment verification companies:",
    info: [
      "Log in to verify candidate profiles instantly.",
      "Complete the process in just 3 easy steps.",
      "A fast, secure platform for employment verification.",
      "Handle more verifications in less time with ease.",
      "Deliver accurate results and build trust with employers.",
    ],
    buttonText: "Coming soon",
    isActive: false,
  },
  {
    id: "ORG",
    userTypekey: "organization",
    icon: "/icons/signup-organiser.png",
    name: "Organization",
    description: "For registered employers:",
    info: [
      "Log in for seamless employment data verification.",
      "Unlock revenue opportunities by offering verification services.",
      "Replace manual processes with faster, digital verifications.",
      "Improve employee onboarding with instant, trusted verification.",
      "Save time with an efficient and user-friendly platform.",
    ],
    buttonText: "Sign in",
    isActive: true,
  },
  {
    id: "IDV",
    userTypekey: "individual",
    icon: "/icons/signup-individual.png",
    name: "Individual",
    description: "For students, graduates, job seekers, and employees:",
    info: [
      "Access and update your verified employment profile anytime.",
      "Share your profile directly with employers to boost credibility.",
      "Skip third-party delays with secure digital verification.",
      "Stay ahead in the job market with a ready-to-share profile.",
      "Connect your profile with your organization effortlessly.",
    ],
    buttonText: "Coming soon",
    isActive: false,
  },
];
